/* eslint-disable @typescript-eslint/no-explicit-any */
import lendingApi from 'apis/lending'
import { constants } from 'apps'
import HorseItem from 'features/Market/components/HorseItem'
import { SwitchBtn } from 'features/Race/components'
import { useDebounce, useToggle, useUpdateEffect } from 'hooks'
import { NOTIFICATION_MESSAGE } from 'i18n/constants'
import { defaultRegionFilters, LendingHorse, LendingSortType, MyAssetSortType, MyHorseListParams, TypeSorts } from 'models'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { OneLineTitle, SearchInput } from 'shared'
import SelectCustom from 'shared/SelectCustom'
import { handleAsyncRequest } from 'utils/helper'
import MarketStyled from './styled'
import { NUMBER, STRING_REGION } from 'apps/constants'

export type IMyLendingProps = {
  isActive: boolean
}


const defaultTypeFilters: TypeSorts = [
  {
    name: LendingSortType.Newest,
    isActive: false
  },
  {
    name: LendingSortType.Oldest,
    isActive: false
  },
  {
    name: MyAssetSortType.Ascending,
    isActive: false
  },
  {
    name: MyAssetSortType.Decrease,
    isActive: false
  }
]

export default function Market() {
  const myHorseListParams: MyHorseListParams = {
    limit: NUMBER.TWENTY,
    page: NUMBER.ONE,
    sort: 'lending_date-desc'
  }
  const [total, setTotal] = useState()
  const [searchValue, setSearchValue] = useState<string>('')
  const [classSelect, setClassSelect] = useState('Sorted by...')
  const [listHorse, setListHorse] = useState<LendingHorse[]>([])
  const debounceSearchValue = useDebounce<string>(searchValue, constants.DEBOUNCE_TIME)
  const [params, setParams] = useState<MyHorseListParams>(myHorseListParams)
  const [isFetch, setIsFetch] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const useRefSwitch = useRef<HTMLButtonElement>(null)
  const { t } = useTranslation()
  const [isMyHorseOn, toggleIsMyHorseOn] = useToggle(false)
  const [isTargeted, toggleIisTargeted] = useToggle(false)
  const [regionSelect, setRegionSelect] = useState('Region')

  const fetchListRaces = async () => {
    const refSwitch = useRefSwitch.current && useRefSwitch.current?.className
    const isRefSwitch = refSwitch?.includes('switch-btn--on')
    setIsLoading(true)
    const [, result]: any = await handleAsyncRequest(lendingApi.getHorseMarket({ ...params, myHorse: isRefSwitch || null, onlyYouCanRent: isTargeted || null }))
    const records = result?.data.records
    setListHorse(params.page > NUMBER.ONE ? [...listHorse, ...records] : records)
    setTotal(result?.data.total)
    setIsFetch(false)
    if (records && records.length === 0) {
      // setLoader(true)
    }
    setIsLoading(false)
  }

  useEffect(() => {
    if (isFetch) {
      setListHorse([])
      setSearchValue('')
      setParams({ ...params, page: NUMBER.ONE })
    }
  }, [isFetch])

  useUpdateEffect(() => {
    setListHorse([])
    setParams({ ...params, page: NUMBER.ONE, horseName: debounceSearchValue })
  }, [debounceSearchValue])

  useUpdateEffect(() => {
    setListHorse([])
    setParams({ ...params, myHorse: isMyHorseOn, page: NUMBER.ONE, onlyYouCanRent: isTargeted })
  }, [isMyHorseOn, isTargeted])

  useEffect(() => {
    fetchListRaces()
  }, [params])

  const handleSearchValueChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value)
  }

  const handleClassFilterClicked = (item: string) => {
    const handleKeySort = () => {
      switch (item) {
        case LendingSortType.Newest:
          return 'lending_date-desc'
        case LendingSortType.Oldest:
          return 'lending_date-asc'
        case MyAssetSortType.Ascending:
          return 'horse_id-asc'
        case MyAssetSortType.Decrease:
          return 'horse_id-desc'
        default:
          return 'lending_date-desc'
      }
    }
    setParams({
      ...params, page: 1, sort: handleKeySort()
    })
    setClassSelect(item)
  }

  const hanldeViewMore = () => {
    setParams({ ...params, page: params.page + NUMBER.ONE })
  }

  const handleNameHorse = () => {
    if (total === NUMBER.ZERO || total === NUMBER.ONE) {
      return 'Horse'
    } else return 'Horses'
  }

  const handleRegionFilterClicked = (item: string) => {
    if (item?.toUpperCase() === STRING_REGION.SEOUL || item?.toUpperCase() === STRING_REGION.TOKYO) {
      setParams({
        ...params, page: NUMBER.ONE, region: item?.toUpperCase()
      })
    } else {
      setParams({
        ...params, page: NUMBER.ONE, region: ''
      })
    }
    setRegionSelect(item)
  }

  return (
    <MarketStyled>
      <div className='top-lending'>
        <OneLineTitle text={handleNameHorse()} total={total} isLending />
        <div className='lending-search'>
          <div className='d-flex mt-1 gap-4'>
            <SwitchBtn
              title='Targeted Lending'
              isOn={isTargeted}
              handleSwitchBtnClicked={toggleIisTargeted}
              refSwitch={useRefSwitch}
            />
            <SwitchBtn
              title={t(`${NOTIFICATION_MESSAGE}.myHorse`)}
              isOn={isMyHorseOn}
              handleSwitchBtnClicked={toggleIsMyHorseOn}
              refSwitch={useRefSwitch}
            />
          </div>
          <SearchInput
            searchValue={searchValue}
            handleSearchValueChanged={handleSearchValueChanged}
            customClass='search-horse-input'
            placeholder={'Search'}
          />
          <SelectCustom
            dataSelect={defaultRegionFilters}
            nameSelect={regionSelect}
            onSelected={handleRegionFilterClicked}
          />
          <SelectCustom
            dataSelect={defaultTypeFilters}
            nameSelect={classSelect}
            onSelected={handleClassFilterClicked}
          />
        </div>
      </div>
      <HorseItem isLoading={isLoading} total={total} listHorse={listHorse} onViewMore={hanldeViewMore} />
    </MarketStyled>
  )
}
